export const priorityOptions = [
	{ label: "High", value: "0" },
	{ label: "Medium", value: "1" },
	{ label: "Low", value: "2" },
];
